import { render, staticRenderFns } from "./DocuEntry.vue?vue&type=template&id=80feae2c&scoped=true&"
import script from "./DocuEntry.vue?vue&type=script&lang=js&"
export * from "./DocuEntry.vue?vue&type=script&lang=js&"
import style0 from "./DocuEntry.vue?vue&type=style&index=0&id=80feae2c&scoped=true&lang=scss&"
import style1 from "./DocuEntry.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80feae2c",
  null
  
)

export default component.exports